import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../services/auth.service';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  var service = inject(AuthService);

  if (!req.url.endsWith('login')) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${service.getJwtToken()}`,
      },
    });
  }
  return next(req);
};
